import { Inject, Injectable } from '@angular/core';
import { AbstractLoutyEntiteService } from 'src/app/core/services/abstract-louty-entite.service';
import { MembreComplementDto, MembreDto } from '../models/membre-dto';
import { MembrePourListeDto } from '../models/membre-pour-liste-dto';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiUrls } from 'src/app/core/helpers/api-urls';
import { Observable } from 'rxjs';
import { TextValeur } from 'src/app/core/models/TextValeur';
import { shareReplay } from 'rxjs/operators';
import { ColumnDto } from 'src/app/core/models/column-dto';
import { Forcable } from 'src/app/core/models/Forcable';
import { IndividuStrutureCompteCollectifDto } from '../models/individu-structure-compte-collectif-dto';
import { NotificationParam } from 'src/app/core/models/notification-param';
import { ProprieteDto } from 'src/app/core/models/propriete-dto';
import { Forcing } from 'src/app/core/models/Forcing';
import { BiValeur } from 'src/app/core/models/bi-valeur';
import { MembreVerifDateDto } from '../models/membre-verif-date-dto';
import { HistoriqueDto } from 'src/app/core/models/historique/historique-dto';
import { SaisieDateFinDto } from 'src/app/core/models/saisie-date-fin-dto';
import { IdCodeLabelActive } from 'src/app/core/models/IdCodeLabelActive';

@Injectable({
  providedIn: 'root',
})
export class MembreService extends AbstractLoutyEntiteService<MembreDto, MembrePourListeDto> {
  // deleteListUrl =
  protected getUrl = ApiUrls.getMembreUrl();
  protected duplicateUrl = '';
  protected saveUrl = ApiUrls.saveMembreUrl();
  protected deleteUrl = ApiUrls.deleteMembreUrl();
  public deleteListUrl = ApiUrls.deleteMembresUrl();
  protected saveListUrl = ApiUrls.saveMembreListUrl();
  protected getListUrl = ApiUrls.getMembreListForEditUrl();
  protected gUrl = ApiUrls.getMembreListForEditUrl();
  protected exportListToFileUrl = ApiUrls.getExportMembresUrl();
  protected getPaginatedListUrl = ApiUrls.getPaginatedMembreListUrl();
  protected getIdNumeroDicoUrl = ApiUrls.getMembreIdNumeroDicoUrl();
  protected quickSearchUrl = ApiUrls.quickSearchMembresUrl();
  protected exportFileName = 'membres';
  civiliteList$: Observable<TextValeur<number>[]>;

  constructor(
    protected http: HttpClient,
    @Inject('API_BASE_URL') protected _apiBaseUrl: string,
  ) {
    super();
    this.getTitreList();
    this.useScroll = true;
  }

  private getTitreList() {
    this.civiliteList$ = this.http.get<TextValeur<number>[]>(this._apiBaseUrl + ApiUrls.getTitreMembreListUrl(), {}).pipe(
      shareReplay(1), // mise en cache
    );
  }

  getMembreInfoComplementaire(membreId: number): Observable<MembreComplementDto> {
    const params = new HttpParams().set('membreId', membreId.toString());
    return this.http.get<MembreComplementDto>(this._apiBaseUrl + ApiUrls.getMembreInfoComplementaire(), { params });
  }

  dissocieLogin(individuStructureId: number, login: string): Observable<any> {
    const params = new HttpParams().set('individuStructureId', individuStructureId + '').set('login', login + '');
    return this.http.post(this._apiBaseUrl + ApiUrls.dissocieLoginUrl(), params);
  }

  inviteACreerCompteLouty(courriel: string, membreId: number): Observable<any> {
    const textValeur = new TextValeur<number>();
    textValeur.text = courriel;
    textValeur.valeur = membreId;
    return this.http.post(this._apiBaseUrl + ApiUrls.inviteACreerCompteLoutyUrl(), JSON.stringify(textValeur), {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  getColonnesFiltrablesList(): Observable<ColumnDto[]> {
    return this.http.get<ColumnDto[]>(this._apiBaseUrl + ApiUrls.getColumnDtoMembreFiltrableListUrl());
  }

  verifieSuffixeOk(id: number, suffixe: string): Observable<Forcable<[string, string, boolean, boolean]>> {
    const params = new HttpParams().set('id', (id || '') + '').set('suffixe', suffixe);
    return this.http.get<Forcable<[string, string, boolean, boolean]>>(this._apiBaseUrl + ApiUrls.verifieSuffixeOkUrl(), { params });
  }

  associeLogin(individuStructureId: number, login: string): Observable<string> {
    const params = new HttpParams().set('individuStructureId', individuStructureId + '').set('login', login + '');
    return this.http.post<string>(this._apiBaseUrl + ApiUrls.associeLoginUrl(), params, { responseType: 'text' as 'json' });
  }

  // vérifie si un compte comptable est supprimable
  verifieCptSupprimable(forcable: Forcable<number>) {
    return this.http.post(this._apiBaseUrl + ApiUrls.verifieCptSupprimableUrl(), JSON.stringify(forcable), {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  getCompteCollectifListForSuffixe(suffixe: string): Observable<IndividuStrutureCompteCollectifDto[]> {
    const params = new HttpParams().set('suffixe', suffixe);
    return this.http.get<IndividuStrutureCompteCollectifDto[]>(this._apiBaseUrl + ApiUrls.getCompteCollectifListForSuffixeUrl(), {
      params,
    });
  }

  envoieNotificationManuelle(notificationParam: NotificationParam, forcer = false): Observable<TextValeur<number>[]> {
    return this.http.post<TextValeur<number>[]>(
      this._apiBaseUrl + ApiUrls.envoieNotificationManuelleUrl(),
      JSON.stringify(new Forcable({ forcer, valeur: notificationParam })),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }

  saveProprieteMembres(propriete: ProprieteDto, forcingKeys: string[]) {
    return this.http.post(
      this._apiBaseUrl + ApiUrls.saveProprieteMembresUrl(),
      JSON.stringify(
        new Forcing({
          keys: forcingKeys,
          value: new BiValeur<number[], ProprieteDto>({
            val1: Array.from(this.panier.keys()),
            val2: propriete,
          }),
        }),
      ),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }

  getMembreVerifDateList(): Observable<MembreVerifDateDto[]> {
    return this.http.get<MembreVerifDateDto[]>(this._apiBaseUrl + ApiUrls.getMembreVerifDateListUrl(), {});
  }

  getmembreVerifDate(membreId: number): Observable<MembreVerifDateDto> {
    const params = new HttpParams().set('membreId', membreId.toString());
    return this.http.get<MembreVerifDateDto>(this._apiBaseUrl + ApiUrls.getMembreVerifDateUrl(), { params });
  }

  saveMembreVerifDate(membreVerifDateDto: MembreVerifDateDto, forcingKeys: string[]) {
    return this.http.post(
      this._apiBaseUrl + ApiUrls.saveMembreVerifDateUrl(),
      JSON.stringify(
        new Forcing({
          keys: forcingKeys,
          value: membreVerifDateDto,
        }),
      ),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }

  public voirHistorique(membreId: number): Observable<HistoriqueDto[]> {
    const params = new HttpParams().set('id', membreId + '');
    return this.http.get<HistoriqueDto[]>(`${this._apiBaseUrl}${ApiUrls.voirMembreHistoriqueUrl()}`, { params });
  }

  public saveDateFinMembres(dto: SaisieDateFinDto, forcingKeys: string[]) {
    return this.http.post(
      this._apiBaseUrl + ApiUrls.saveDateFinMembresUrl(),
      JSON.stringify(
        new Forcing({
          keys: forcingKeys,
          value: new BiValeur<number[], SaisieDateFinDto>({
            val1: Array.from(this.panier.keys()),
            val2: dto,
          }),
        }),
      ),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }

  public saveNotifPreferences(idsKeyHash: string, forcingKeys: string[]): Observable<any> {
    return this.http.post(
      this._apiBaseUrl + ApiUrls.saveMembreNotifsPreferencesUrl(),
      JSON.stringify(
        new Forcing({
          keys: forcingKeys,
          value: idsKeyHash,
        }),
      ),
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) },
    );
  }
  public getActivitePrincipaleId(id: number) {
    const params = new HttpParams().set('membreId', id + '');
    return this.http.get<number>(`${this._apiBaseUrl}${ApiUrls.activitePrincipaleDuMembreUrl()}`, { params });
  }

  exportIbanMembre(): Observable<any> {
    const membreIds: string = Array.from(this.panier.keys()).join(', ');
    console.log(membreIds);
    const params = new HttpParams().set('membreIds', membreIds + '');
    return this.http.post(this._apiBaseUrl + ApiUrls.exportIbanMembreUrl(), params);
  }

  public getMembreAuProfilStructureList(): Observable<IdCodeLabelActive[]> {
    const params = new HttpParams();
    return this.http.get<IdCodeLabelActive[]>(`${this._apiBaseUrl}${ApiUrls.getMembreAuProfilStructureListUrl()}`, { params });
  }
}
